import {
  BASE_PATH_API,
  STATIC_TOKEN_CONNECTION,
  BASE_PATH_REPOSITORIO,
  BASE_PATH_UPLOAD_SOC_REPO,
  PATH_GET_SOLICITUDES,
  PATH_GET_SOLICITUD_DETALLE_ID,
  PATH_POST_NEW_SOLICITUDE,
  PATH_POST_NEW_SOLICITUDE_DETAIL,
  PATH_DATA_DASHBOARD_TUTORIAL,
  PATH_POST_BUDGET,
  PATH_GET_DIGITAL_SIGN,
  PATH_POST_NEW_DIGITAL_SIGN,
  PATH_FILE_UPLOAD,
  PATH_FILE_DOWNLOAD,
  PATH_GET_SOLICITUDES_DETALLES,
  PATH_FILE_DOWNLOAD_FOLDER,
  PATH_FILE_DELETE_ZIP,
  PATH_GET_SOLICITUDES_STATISTICS_YEAR,
  PATH_GET_SOLICITUDES_STATISTICS_MONTH,
  PATH_PPTO_STATISTICS_MONTH,
  PATH_PPTO_STATISTICS_YEAR,
  PATH_GET_SOLICITUDE_PPTO_STATISTICS_YEAR,
  PATH_GET_SOLICITUDE_PPTO_STATISTICS_MONTH,
  PATH_GET_ALL_PPTO_SOLICITUDE_MONTHS,
  PATH_GET_PPTO_DISPONIBLE_CC,
  PATH_GET_PPTO_SOLICITADO_CC,
  PATH_SEND_EMAIL_NOTIFICATION,
  PATH_PUT_UPD_SOLICITUDE,
  PATH_PUT_UPD_SOLICITUDE_DETAIL,
  PATH_POST_SOLICITUDE_APPROVAL_STATE,
  PATH_GET_SOLICITUDE_APPROVALS_STATES,
  PATH_GET_PURCHASE_ORDERS_STATISTICS_YEAR,
  PATH_GET_PURCHASE_ORDERS_STATISTICS_MONTH,
  PATH_GET_PURCHASE_ORDERS_PPTO_STATISTICS_YEAR,
  PATH_GET_PURCHASE_ORDERS_PPTO_STATISTICS_MONTH,
  PATH_GET_ALL_PPTO_PURCHASE_ORDERS_MONTHS,
  BASE_PATH_MINDICADOR_CL,
  PATH_MINDICADOR_DOLAR_DIARIO,
  PATH_MINDICADOR_UF_DIARIO,
  PATH_MINDICADOR_EURO_DIARIO,
  PATH_GET_ORDENES_COMPRA,
  PATH_GET_ORDENES_COMPRA_DETALLES,
  PATH_GET_ORDEN_COMPRA_DATA,
  PATH_POST_NEW_ORDEN_COMPRA,
  PATH_POST_NEW_ORDEN_COMPRA_DETAIL,
  PATH_GET_PPTO_TOMADO_ORDENES_CC,
  PATH_GET_ORDENES_COMPRA_APPROVALS_STATES,
  PATH_PUT_UPD_ORDEN_COMPRA,
  PATH_PUT_UPD_ORDEN_COMPRA_DETAIL,
  PATH_POST_ORDENES_COMPRA_APPROVAL_STATE,
  PATH_GET_SOLICITUDES_COMPRA_BY_ESTADO,
  PATH_GET_SOLICITUDES_COMPRA_BY_ESTADO_DETALLES,
  PATH_GET_STATISTICS_RECENT_SOLICITUDES,
  PATH_GET_SOLICITUDES_STATISTICS_CENTROS,
  PATH_GET_ORDENES_STATISTICS_CENTROS,
  PATH_GET_STATISTICS_RECENT_ORDENES,
  PATH_GET_SIGN_SOLICITUDE_HISTORY,
  PATH_GET_VALID_DIGITAL_SIGN,
  PATH_GET_VALID_DIGITAL_SIGN_PURCHASE_ORDER,
  PATH_POST_NEW_SIGN_APPROVAL_HIS_SOLICITUDE,
  PATH_POST_NEW_SIGN_APPROVAL_HIS_ORDER,
  PATH_GET_DATOS_PROVEEDORES,
  PATH_GET_LAST_PRICE_ITEM_SELECTED,
  PATH_GET_SIGN_ORDEN_HISTORY,
  PATH_POST_LAST_PRICE_STOCK_ITEM,
  PATH_FILE_UPLOAD_DOCUMENT,
  PATH_SEND_EMAIL_NOTIFICATION_ATTACH_REPO,
  BASE_PATH_API_INET,
  PATH_ADD_ORDEN_COMPRA_INET,
  PATH_ADD_ORDEN_COMPRA_DETALLE_INET,
  PATH_ADD_ORDEN_COMPRA_DETALLE_GLOSA_INET,
  PATH_PUT_ORDENES_STATE_GTE,
  FORMAT_DATETIME_DDMMYYYY,
  FORMAT_DATETIME_DDMMYYYY_GUION,
  PATH_GET_EMAILS_DESTINATARIES_SOL,
  PATH_GET_EMAILS_DESTINATARIES_ORD,
  PATH_GET_ORDEN_COMPRA_DETALLE_ID,
  getUserIp,
  PATH_POST_ORDEN_EMITIDA,
  PATH_POST_ORDEN_VISTA_MARCA,
  PATH_PUT_ORDEN_COMPRA_NULA_INET,
  PATH_PUT_ORDEN_COMPRA_NULA,
  PATH_GET_ORDENES_FACTURAS_PAGOS,
  PATH_GET_SII_INVOICE,
  PATH_ADD_RECEPCION_SERVICIOS_INET,
  PATH_GET_ORDENES_FACTURAS_PAGINATED,
  PATH_GET_DTE_PDF,
  PATH_ADD_RECEPCION_DOCUMENTO,
  PATH_POST_ORDEN_COMPRA_ESTADO_INET,
  PATH_GET_REPORTES_FINANZAS,
  PATH_GET_REPORTES,
  PATH_GET_EMAIL_LOG_ORDENES_EMITIDAS,
} from "./Constants";

class APIError extends Error {
  type: any;
  status: any;
  statusText: string;
  constructor(
    res: Response,
    data: {
      errors?: any;
      error?: any;
      message?: any;
      type?: any;
    },
  ) {
    super(
      data.errors
        ? data.errors[0]
        : data.error || data.message || res.statusText || res.status,
    );

    this.name = "APIError";
    this.type = data.type;
    this.status = res.status;
    this.statusText = data.message;

    console.log("APIError: ", this.status, this.statusText);
  }
}

function getToken() {
  //ES POSIBLE TENER QUE LLAMAR A ACQUIRE TOKEN SI SE HACE NO VALIDO AQUI
  const sessionStorageTokenApi = sessionStorage.getItem("accessToken");
  if (sessionStorageTokenApi !== null) {
    return sessionStorageTokenApi;
  }
}

function buildPath(path: string[]) {
  const normalizedPath = path[0] === "/" ? path : `${path}`;
  return BASE_PATH_API + normalizedPath;
}

function makeRequest(
  path: string[],
  options: {
    method?: any;
    body?: any | undefined;
    headers?: { [key: string]: string } | undefined;
  },
) {
  try {
    const { method = "GET", body, headers = {} } = options;

    const normalizedBody = typeof body === "object" ? body : body;

    //const authCookie = true; //readAuthCookie();
    //if (authCookie) {
    //headers["Authorization"] = STATIC_TOKEN_CONNECTION; //`Bearer: ${authCookie}`;
    headers["Authorization"] = `Bearer ${getToken()}`;
    //}
    //}

    headers["Content-Type"] = "application/json";
    headers["Accept"] = "application/json";
    headers["Access-Control-Allow-Origin"] =
      "https://fishweb.salmonesdechile.com, http://localhost:3000, http://172.17.1.35:3000";
    headers["Access-Control-Allow-Methods"] = BASE_PATH_API_INET;
    ("GET, POST, PATCH, PUT, DELETE, OPTIONS");
    headers["Access-Control-Allow-Headers"] =
      "Origin, Content-Type, X-Auth-Token";

    return new Request(buildPath(path), {
      method,
      body: normalizedBody,
      headers,
    });
  } catch (error) {
    console.log(error);
  }
}

async function callApi(path: any, options: any) {
  const req = makeRequest(path, options);
  if (!req) {
    throw new Error("Failed to create request");
  }
  const res = await window.fetch(req);

  if (!res.ok) {
    let data = {};
    try {
      data = await res.json();
    } catch (error) {
      console.log("ERROR: " + error);
    }
    throw new APIError(res, data);
  }

  if (res.status === 204) {
    return;
  } else if (res.status === 202) {
    return 202;
  }

  /*else {
      let data = {};
      try {
        data = await res.json();
        throw new APIError(res, data);
      } catch (error) {
        console.log("ERROR: " + error);
      }
    }*/

  try {
    let respuesta;
    if (res !== null) {
      respuesta = await res.json();

      if (respuesta.data !== null) {
        return respuesta;
      } else {
        console.log("Res: ", respuesta);
      }
    } else {
      return {};
    }
  } catch (e) {
    return {};
  }

  /*try {
      return await res.json();
    } catch (error) {
      console.log("ERROR DE CALL API", error);
      // The server's response was not application/JSON
      /*errorTracker.log(
        new Error(
          `Expected a JSON response for ${req.method} ${
            req.url
          }. Got something else.`
        )
      );/
  
      return {};
    }*/
}

/***************************************************************/
/*********************  API CALLS ******************************/
/***************************************************************/
/*export const SET_PROCESO_REACREDITACION = {
    async setProcesoParaReacreditacion(id) {
      var path = `${PATH_REACREDITACION_SET_PROCESO}`;
      const data = await callApi(path, {
        method: "POST",
        body: [client, id]
      });
      return data;
    }
  }*/

export const FILE_UPLOAD = {
  async fileBlobUpload(dataBlob: any) {
    var path = [`${PATH_FILE_UPLOAD}`];
    const response = await callApi(path, {
      method: "POST",
      body: [dataBlob],
    });
    return response;
  },
};

export const FILE_UPLOAD_ORDER = {
  async fileBlobUploadOrder(
    dataBlob: any,
    ano: number,
    mes: number,
    typeDoc: string,
    id: number,
  ) {
    var path = `${BASE_PATH_API}${PATH_FILE_UPLOAD_DOCUMENT}?ano=${ano}&mes=${mes}&typeDoc=${typeDoc}&id=${id}`;
    const response = await fetch(path, {
      method: "POST",
      body: dataBlob,
    });
    return response;
  },
};

export const FILE_DOWNLOAD = {
  async fileDownload(url: string) {
    var path = [`${PATH_FILE_DOWNLOAD}?path=${url}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
    /*  var path = `${BASE_PATH_API}${PATH_FILE_DOWNLOAD}?path=${url}`;
    const response = await fetch(path);
    console.log("CHECK RESPONSE: ", response);
    const blob = await response.blob();
    const blobURL = window.URL.createObjectURL(new Blob([blob]));
    const fileName = url.split("/").pop();
    const aTag = document.createElement("a");
    aTag.href = blobURL;
    aTag.setAttribute("download", fileName + ".zip" || "file");
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();*/
  },
};

export const FILES_DOWNLOAD_LOCAL = {
  async fileDownloadLocal(url: string) {
    var path = `${BASE_PATH_API}${PATH_FILE_DOWNLOAD_FOLDER}?path=${url}`;
    const response = await fetch(path);

    if (response.status !== 200) {
      return null;
    }

    const blob = await response.blob();
    const blobURL = window.URL.createObjectURL(new Blob([blob]));
    const fileName = url.split("/").pop();
    const aTag = document.createElement("a");
    aTag.href = blobURL;
    aTag.setAttribute("download", fileName + ".zip" || "file");
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
  },
};

export const FILE_TMP_DELETE_ZIP = {
  async fileZipDelete(url: string) {
    var path = [`${PATH_FILE_DELETE_ZIP}?path=${url}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

/*
export const FILE_DOWNLOAD = {
  //POST ARCHIVO BLOB PARA SER ALMACENADO EN S3
  async fileDownload(url: string) {
    var path = [`${PATH_FILE_DOWNLOAD}?path=${url}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const FILES_DOWNLOAD_FOLDER = {
  //POST ARCHIVO BLOB PARA SER ALMACENADO EN S3
  async filesDownloadFolder(url: string, numDoc: string) {
    var path = `${BASE_PATH_API}${PATH_FILE_DOWNLOAD_FOLDER}?path=${url}&fileNameZipped=${numDoc}`;
    const response = await fetch(path);
    console.log("CHECK RESPONSE: ", response);
    const blob = await response.blob();
    const blobURL = window.URL.createObjectURL(new Blob([blob]));
    const fileName = url.split("/").pop();
    const aTag = document.createElement("a");
    aTag.href = blobURL;
    aTag.setAttribute("download", fileName + ".zip" || "file");
    document.body.appendChild(aTag);
    aTag.click();
    aTag.remove();
  },
};*/

{
  /*export const GET_HANDSONTABLE = {
    async getHandsonTable(table) {
      console.log('cliente: '+client);
      var path = `${PATH_GET_HANDSONTABLE}?cliente=${client}`;
      const data = await callApi(path, {
        method: "POST",
        body: [client, table]
      });
      return data;
    },
  };*/
}

export const GET_DATA_DASHBOARD_TUTORIAL = {
  async getDataTutorial() {
    var path = [`${PATH_DATA_DASHBOARD_TUTORIAL}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

//############### PRESUPUESTOS ###################//

export const SEND_BUDGET = {
  async sendBudget(data: any) {
    var path = [`${PATH_POST_BUDGET}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

//############## SOLICITUDES ###################//
export const GET_SOLICITUDES_ORDENES = {
  async getSolicitudesOrdenes(
    idCentro: number,
    contexto: string,
    idUser: number,
    centrosCostoVista: string,
    roles: any,
    subrogante: any,
  ) {
    var path = [
      `${PATH_GET_SOLICITUDES}?idCentroCosto=${idCentro}&contexto=${contexto}&idUser=${idUser}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subrogante}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_SOLICITUDES_DETALLE_ORDENES = {
  async getSolicitudesDetalleOrdenes(
    idCentro: number,
    idRol: number,
    contexto: string,
    idUser: number,
    centrosCostoVista: string,
    roles: any,
    subrogante: any,
  ) {
    var path = [
      `${PATH_GET_SOLICITUDES_DETALLES}?idCentroCosto=${idCentro}&idRol=${idRol}&contexto=${contexto}&idUser=${idUser}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subrogante}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_SOLICITUD_ORDEN = {
  async getSolicitudOrdenById(id: number) {
    var path = [`${PATH_GET_SOLICITUDES}/${id}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const SEND_NUEVA_SOLICITUD = {
  async sendNewSolicitude(data: any) {
    var path = [`${PATH_POST_NEW_SOLICITUDE}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const SEND_NUEVA_SOLICITUD_DETALLE = {
  async sendNewSolicitudeDetail(data: any) {
    var path = [`${PATH_POST_NEW_SOLICITUDE_DETAIL}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const SEND_NUEVA_FIRMA_DIGITAL = {
  async sendNewDigitalSign(data: any) {
    var path = [`${PATH_POST_NEW_DIGITAL_SIGN}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const GET_FIRMA_DIGITAL_BY_ID = {
  async getDigitalSignById(id: number) {
    var path = [`${PATH_GET_DIGITAL_SIGN}/${id}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

//*************** ESTADISTICAS**************//

//ESTADOS
export const GET_SOLICITUDES_STATISTICS_YEAR = {
  async getSolicitudeStatisticsYear(
    idUser: number,
    idCentroCosto: number,
    centrosCostoVista: any,
    roles: any,
    subroganteVal: any,
  ) {
    var path = [
      `${PATH_GET_SOLICITUDES_STATISTICS_YEAR}/${idUser}?idCentroCosto=${idCentroCosto}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subroganteVal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_SOLICITUDES_STATISTICS_MONTH = {
  async getSolicitudeStatisticsMonth(
    idUser: number,
    idCentroCosto: number,
    centrosCostoVista: any,
    roles: any,
    subroganteVal: any,
  ) {
    var path = [
      `${PATH_GET_SOLICITUDES_STATISTICS_MONTH}/${idUser}?idCentroCosto=${idCentroCosto}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subroganteVal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

//SUMATORIAS
export const GET_PPTO_STATISTICS_YEAR = {
  async getPptoStatisticsYear(
    idUser: number,
    idCentroCosto: number,
    centrosCostoVista: any,
    roles: any,
    subroganteVal: any,
  ) {
    var path = [
      `${PATH_PPTO_STATISTICS_YEAR}/${idUser}?idCentroCosto=${idCentroCosto}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subroganteVal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_PPTO_STATISTICS_MONTH = {
  async getPptoStatisticsMonth(
    idUser: number,
    idCentroCosto: number,
    centrosCostoVista: any,
    roles: any,
    subroganteVal: any,
  ) {
    var path = [
      `${PATH_PPTO_STATISTICS_MONTH}/${idUser}?idCentroCosto=${idCentroCosto}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subroganteVal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_SOLICITUDE_REF_PPTO_STATISTICS_YEAR = {
  async getSolicitudeRefPptoStatisticsYear(
    idUser: number,
    idCentroCosto: number,
  ) {
    var path = [
      `${PATH_GET_SOLICITUDE_PPTO_STATISTICS_YEAR}/${idUser}?idCentroCosto=${idCentroCosto}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_SOLICITUDE_REF_PPTO_STATISTICS_MONTH = {
  async getSolicitudeRefPptoStatisticsMonth(
    idUser: number,
    idCentroCosto: number,
  ) {
    var path = [
      `${PATH_GET_SOLICITUDE_PPTO_STATISTICS_MONTH}/${idUser}?idCentroCosto=${idCentroCosto}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_ALL_PPTO_SOLICITUDE_MONTHS = {
  async getAllPptoSolicitudeMonths(
    idUser: number,
    idCentroCosto: number,
    centrosCostoVista: any,
    roles: any,
    subroganteVal: any,
  ) {
    var path = [
      `${PATH_GET_ALL_PPTO_SOLICITUDE_MONTHS}/${idUser}?idCentroCosto=${idCentroCosto}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subroganteVal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_PPTO_DISPONIBLE_CC = {
  async getPptoCentroCosto(
    idUser: number,
    idCentroCosto: number,
    idItem: number,
  ) {
    var path = [
      `${PATH_GET_PPTO_DISPONIBLE_CC}/${idUser}?idCentroCosto=${idCentroCosto}&idItem=${idItem}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_PPTO_SOLICITADO_CC = {
  async getPptoDisponibleCentroCosto(
    idUser: number,
    idCentroCosto: number,
    idMesGasto: number,
    idItem: number,
  ) {
    var path = [
      `${PATH_GET_PPTO_SOLICITADO_CC}/${idUser}?idCentroCosto=${idCentroCosto}&idMesGasto=${idMesGasto}&idItem=${idItem}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const POST_SEND_EMAIL_NOTIFICATION = {
  async sendNewEmail(data: any) {
    var path = [`${PATH_SEND_EMAIL_NOTIFICATION}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const POST_SEND_EMAIL_NOTIFICATION_ATTACH_REPO = {
  async sendNewEmailWithAttachmentRepo(data: any) {
    var path = [`${PATH_SEND_EMAIL_NOTIFICATION_ATTACH_REPO}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const PUT_UPD_SOLICITUDE = {
  async putUpdateSolicitude(id: number, data: any) {
    var path = `${PATH_PUT_UPD_SOLICITUDE}/${id}`;
    const response = await callApi(path, {
      method: "PUT",
      body: data,
    });
    return response;
  },
};

export const PUT_UPD_SOLICITUDE_DETAIL = {
  async putUpdateSolicitudeDetail(id: number, data: any) {
    var path = `${PATH_PUT_UPD_SOLICITUDE_DETAIL}/${id}`;
    const response = await callApi(path, {
      method: "PUT",
      body: data,
    });
    return response;
  },
};

export const POST_SOLICITUDE_APPROVAL_STATE = {
  async sendSolicitudeApprovalState(id: number, data: any) {
    var path = [`${PATH_POST_SOLICITUDE_APPROVAL_STATE}/${id}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const GET_SOLICITUDE_APPROVALS_STATES = {
  async getSolicitudesApprovalStates(idSolicitude: number) {
    var path = [`${PATH_GET_SOLICITUDE_APPROVALS_STATES}/${idSolicitude}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const GET_SOLICITUDES_COMPRA_BY_ESTADO = {
  async getSolicitudesCompraByEstado(
    idEstadoRangoInicial: number,
    idEstadoRangoFinal: number,
  ) {
    var path = [
      `${PATH_GET_SOLICITUDES_COMPRA_BY_ESTADO}?idEstadoRangoInicial=${idEstadoRangoInicial}&idEstadoRangoFinal=${idEstadoRangoFinal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_SOLICITUDES_COMPRA_BY_ESTADO_DETALLES = {
  async getSolicitudesCompraByEstadoDetalle(idEstadoDetalle: number) {
    var path = [
      `${PATH_GET_SOLICITUDES_COMPRA_BY_ESTADO_DETALLES}?idEstadoDetalle=${idEstadoDetalle}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};
/*************************** ORDENES DE COMPRA *************************************/

export const GET_ORDENES_COMPRA = {
  async getOrdenesCompra(
    idUser: number,
    idCentroCosto: number,
    contextmenu: string,
    centrosCostoVista: string,
    roles: any,
    subroganteVal: any,
  ) {
    var path = [
      `${PATH_GET_ORDENES_COMPRA}/${idUser}?idCentroCosto=${idCentroCosto}&contexto=${contextmenu}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subroganteVal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

/*export const GET_ORDEN_COMPRA_BY_ID = {
  async getOrdenCompraById(id: number) {
    var path = [`${PATH_GET_ORDENES_COMPRA}/${id}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};*/

export const GET_ORDENES_COMPRA_DETALLES = {
  async getOrdenesCompraDetalle() {
    var path = [`${PATH_GET_ORDENES_COMPRA_DETALLES}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_ORDEN_COMPRA_BY_ID = {
  async getOrdenCompraById(id: number) {
    var path = [`${PATH_GET_ORDEN_COMPRA_DATA}/${id}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_ORDEN_COMPRA_BY_DETALLE_ID = {
  async getOrdenCompraDetailById(id: number) {
    var path = [`${PATH_GET_ORDEN_COMPRA_DETALLE_ID}/${id}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const SEND_NUEVA_ORDEN_COMPRA = {
  async sendNewOrdenCompra(data: any) {
    var path = [`${PATH_POST_NEW_ORDEN_COMPRA}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const SEND_NUEVA_ORDEN_COMPRA_DETALLE = {
  async sendNewOrdenCompraDetail(data: any) {
    const userIp = await getUserIp();
    var path = [`${PATH_POST_NEW_ORDEN_COMPRA_DETAIL}/${userIp}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const GET_ORDENES_COMPRA_STATISTICS_YEAR = {
  async getOrdenesCompraStatisticsYear(
    idUser: number,
    idCentroCosto: number,
    centrosCostoVista: any,
    roles: any,
    subroganteVal: any,
  ) {
    var path = [
      `${PATH_GET_PURCHASE_ORDERS_STATISTICS_YEAR}/${idUser}?idCentroCosto=${idCentroCosto}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subroganteVal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_ORDENES_COMPRA_STATISTICS_MONTH = {
  async getOrdenesCompraStatisticsMonth(
    idUser: number,
    idCentroCosto: number,
    centrosCostoVista: any,
    roles: any,
    subroganteVal: any,
  ) {
    var path = [
      `${PATH_GET_PURCHASE_ORDERS_STATISTICS_MONTH}/${idUser}?idCentroCosto=${idCentroCosto}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subroganteVal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_ORDENES_COMPRA_PPTO_STATISTICS_YEAR = {
  async getOrdenesCompraPptoStatisticsYear(
    idUser: number,
    idCentroCosto: number,
    centrosCostoVista: any,
    roles: any,
    subroganteVal: any,
  ) {
    var path = [
      `${PATH_GET_PURCHASE_ORDERS_PPTO_STATISTICS_YEAR}/${idUser}?idCentroCosto=${idCentroCosto}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subroganteVal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

/*export const GET_ORDENES_COMPRA_PPTO_STATISTICS_MONTH = {
  async getOrdenesCompraPptoStatisticsMonth(
    idUser: number,
    idCentroCosto: number,
  ) {
    var path = [
      `${PATH_GET_PURCHASE_ORDERS_PPTO_STATISTICS_MONTH}/${idUser}?idCentroCosto=${idCentroCosto}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};*/

export const GET_ALL_PPTO_ORDENES_COMPRA_MONTHS = {
  async getAllPptoOrdenesCompraMonths(
    idUser: number,
    idCentroCosto: number,
    centrosCostoVista: any,
    roles: any,
    subroganteVal: any,
  ) {
    var path = [
      `${PATH_GET_ALL_PPTO_PURCHASE_ORDERS_MONTHS}/${idUser}?idCentroCosto=${idCentroCosto}&centrosCostoVista=${centrosCostoVista}&roles=${roles}&subrogante=${subroganteVal}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_PPTO_TOMADO_CC = {
  async getPptoTomadoCentroCosto(
    idUser: number,
    idCentroCosto: number,
    idMesGasto: number,
    idItem: number,
  ) {
    var path = [
      `${PATH_GET_PPTO_TOMADO_ORDENES_CC}/${idUser}?idCentroCosto=${idCentroCosto}&idMesGasto=${idMesGasto}&idItem=${idItem}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const PUT_UPD_ORDEN_COMPRA = {
  async putUpdateOrdenCompra(id: number, data: any) {
    var path = `${PATH_PUT_UPD_ORDEN_COMPRA}/${id}`;
    const response = await callApi(path, {
      method: "PUT",
      body: data,
    });
    return response;
  },
};

export const PUT_UPD_ORDEN_COMPRA_DETAIL = {
  async putUpdateOrdenCompraDetail(id: number, data: any) {
    var path = `${PATH_PUT_UPD_ORDEN_COMPRA_DETAIL}/${id}`;
    const response = await callApi(path, {
      method: "PUT",
      body: data,
    });
    return response;
  },
};

export const POST_ORDENES_COMPRA_APPROVAL_STATE = {
  async sendOrdenCompraApprovalState(id: number, data: any) {
    var path = [`${PATH_POST_ORDENES_COMPRA_APPROVAL_STATE}/${id}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const GET_ORDENES_COMPRA_APPROVALS_STATES = {
  async getOrdenesCompraApprovalStates(idOrdenCompra: number) {
    var path = [`${PATH_GET_ORDENES_COMPRA_APPROVALS_STATES}/${idOrdenCompra}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const GET_STATISTICS_RECENT_SOLICITUDES = {
  async getStatisticsRecentSolicitudes(idUser: number) {
    var path = [`${PATH_GET_STATISTICS_RECENT_SOLICITUDES}/${idUser}}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const GET_STATISTICS_SOLICITUDES_COST_CENTER = {
  async getStatisticsSolicitudesCostCenter(idUser: number) {
    var path = [`${PATH_GET_SOLICITUDES_STATISTICS_CENTROS}/${idUser}}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const GET_STATISTICS_RECENT_ORDENES = {
  async getStatisticsRecentOrdenes(idUser: number) {
    var path = [`${PATH_GET_STATISTICS_RECENT_ORDENES}/${idUser}}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const GET_STATISTICS_ORDENES_COST_CENTER = {
  async getStatisticsOrdenesCostCenter(idUser: number) {
    var path = [`${PATH_GET_ORDENES_STATISTICS_CENTROS}/${idUser}}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

/***************** INDICADORES *********************/

export const GET_INDICADOR_CAMBIO_DOLAR_DIA = {
  async getIndicadorCambioDolarDia() {
    var path = `${BASE_PATH_MINDICADOR_CL}${PATH_MINDICADOR_DOLAR_DIARIO}${FORMAT_DATETIME_DDMMYYYY_GUION(
      new Date().toISOString(),
    )}`;
    const response = await fetch(path, {
      method: "GET",
      headers: {
        Authorization: STATIC_TOKEN_CONNECTION,
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "http://localhost:3000",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
      },
    });
    return response;
  },
};

export const GET_INDICADOR_CAMBIO_UF_DIA = {
  async getIndicadorCambioUfDia() {
    var path = `${BASE_PATH_MINDICADOR_CL}${PATH_MINDICADOR_UF_DIARIO}${FORMAT_DATETIME_DDMMYYYY_GUION(
      new Date().toISOString(),
    )}`;
    const response = await fetch(path, {
      method: "GET",
      headers: {
        Authorization: STATIC_TOKEN_CONNECTION,
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "http://localhost:3000",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
      },
    });
    return response;
  },
};

export const GET_INDICADOR_CAMBIO_EURO_DIA = {
  async getIndicadorCambioEuroDia() {
    var path = `${BASE_PATH_MINDICADOR_CL}${PATH_MINDICADOR_EURO_DIARIO}${FORMAT_DATETIME_DDMMYYYY_GUION(
      new Date().toISOString(),
    )}`;
    const response = await fetch(path, {
      method: "GET",
      headers: {
        Authorization: STATIC_TOKEN_CONNECTION,
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
      },
    });
    return response;
  },
};

export const GET_SIGN_SOLICITUDE_HISTORY = {
  async getSignSolicitudeHistory(idSolicitude: number) {
    var path = [`${PATH_GET_SIGN_SOLICITUDE_HISTORY}/${idSolicitude}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const GET_VALIDATION_DIGITAL_SIGN = {
  async getValidationDigitalSign(idSolicitude: number, algoritmo: string) {
    var path = [
      `${PATH_GET_VALID_DIGITAL_SIGN}/${idSolicitude}?algoritmo=${algoritmo}`,
    ];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const GET_VALIDATION_DIGITAL_SIGN_PURCHASE_ORDER = {
  async getValidationDigitalSignPurchaseOrder(
    idOrder: number,
    algoritmo: string,
  ) {
    var path = [
      `${PATH_GET_VALID_DIGITAL_SIGN_PURCHASE_ORDER}/${idOrder}?algoritmo=${algoritmo}`,
    ];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const SEND_NEW_APPROVAL_SIGN_HIS_SOLICITUDE = {
  async sendNewApprovalSignHisSolicitude(data: any) {
    var path = [`${PATH_POST_NEW_SIGN_APPROVAL_HIS_SOLICITUDE}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const SEND_NEW_APPROVAL_SIGN_HIS_ORDER = {
  async sendNewApprovalSignHisOrder(data: any) {
    var path = [`${PATH_POST_NEW_SIGN_APPROVAL_HIS_ORDER}`];
    const response = await callApi(path, {
      method: "POST",
      body: [data],
    });
    return response;
  },
};

export const GET_DATOS_PROVEEDORES_BY_ID = {
  async getDataProveedorById(idProveedor: number) {
    var path = [`${PATH_GET_DATOS_PROVEEDORES}/${idProveedor}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const GET_LAST_PRICE_ITEM_SELECTED = {
  async getLastPriceItemSelected(idItem: number) {
    var path = [`${PATH_GET_LAST_PRICE_ITEM_SELECTED}/${idItem}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const GET_SIGN_ORDER_HISTORY = {
  async getSignOrderHistory(idOrden: number) {
    var path = [`${PATH_GET_SIGN_ORDEN_HISTORY}/${idOrden}`];
    const response = await callApi(path, {
      method: "GET",
    });
    return response;
  },
};

export const POST_LAST_PRICE_STOCK_ITEM = {
  async postLastPriceStockItem(data: any) {
    var path = [`${PATH_POST_LAST_PRICE_STOCK_ITEM}`];
    const response = await callApi(path, {
      method: "POST",
      body: data,
    });
    return response;
  },
};

export const PUT_ORDENES_STATE_GTE = {
  async putUpdateOrdenCompraStateGte(id: number, data: any) {
    var path = `${PATH_PUT_ORDENES_STATE_GTE}/${id}`;
    const response = await callApi(path, {
      method: "PUT",
      body: data,
    });
    return response;
  },
};

export const GET_EMAILS_DESTINATARIES_SOL = {
  async getEmailsDestinatariesSol(
    idSolicitude: number,
    idSolicitudeDetail: number,
    typeOperation: string,
  ) {
    var path = [
      `${PATH_GET_EMAILS_DESTINATARIES_SOL}/${idSolicitude}?idSolicitudeDetail=${idSolicitudeDetail}&typeOperation=${typeOperation}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_EMAILS_DESTINATARIES_ORD = {
  async getEmailsDestinatariesOrd(
    idOrden: number,
    idOrdenDetail: number,
    typeOperation: string,
  ) {
    var path = [
      `${PATH_GET_EMAILS_DESTINATARIES_ORD}/${idOrden}?idOrdenDetail=${idOrdenDetail}&typeOperation=${typeOperation}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const POST_ORDEN_EMITIDA = {
  async postOrdenCompraEmitida(data: any) {
    const parsedData = JSON.parse(data);

    var path = [
      `${PATH_POST_ORDEN_EMITIDA}/${parseInt(parsedData.id_orden_compra)}`,
    ];
    const response = await callApi(path, {
      method: "POST",
      body: data,
    });

    /*const response = await fetch(path, {
      method: "POST",
      headers: {
        Authorization: STATIC_TOKEN_CONNECTION,
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin":
          "https://fishweb.salmonesdechile.com, http://localhost:3000",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
      },
      body: data,
    });*/
    return response;
  },
};

export const POST_ORDEN_VISTA_MARCA = {
  async postOrdenVistaMarca(idOrdenCompra: number, idUsuario: number) {
    var path = [
      `${PATH_POST_ORDEN_VISTA_MARCA}/${idOrdenCompra}?id_usuario=${idUsuario}`,
    ];
    const response = await callApi(path, {
      method: "POST",
    });
    return response;
  },
};

export const PUT_ORDEN_COMPRA_NULA = {
  async putUpdateOrdenCompraNula(id: number, data: any) {
    var path = `${PATH_PUT_ORDEN_COMPRA_NULA}/${id}`;
    const response = await callApi(path, {
      method: "PUT",
      body: data,
    });
    return response;
  },
};

/* ########################################################## */
/* ######################### FINANZAS ####################### */

export const GET_ORDENES_FACTURAS_PAGOS = {
  async getOrdenesFacturasPagos(idUser: number, centrosCostoVista: string) {
    var path = [
      `${PATH_GET_ORDENES_FACTURAS_PAGOS}/${idUser}?centrosCostoVista=${centrosCostoVista}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_SII_INVOICE = {
  async getSiiInvoice(dataInvoice: any) {
    var path = [`${PATH_GET_SII_INVOICE}`];
    const data = await callApi(path, {
      method: "POST",
      body: dataInvoice,
    });
    return data;
  },
};

export const GET_ORDENES_FACTURAS_PAGINATED = {
  async getOrdenesPaginated(page: number, limit: number) {
    var path = [
      `${PATH_GET_ORDENES_FACTURAS_PAGINATED}?page=${page}&limit=${limit}`,
    ];
    const data = await callApi(path, {
      method: "GET",
    });
    return data;
  },
};

export const GET_DTE_PDF_INVOICE = {
  async getDtePdf(rutProveedor: string, numeroInterno: number) {
    var path = [`${PATH_GET_DTE_PDF}/${rutProveedor}/${numeroInterno}`];
    const data = await callApi(path, {
      method: "GET",
    });
    return data.pdfBase64;
  },
};

export const ADD_RECEPCION_DOCUMENTO = {
  async addRecepcionDocumento(data: any) {
    var path = `${PATH_ADD_RECEPCION_DOCUMENTO}`;
    const response = await callApi(path, {
      method: "POST",
      body: data,
    });
    return response;
  },
};

export type ReporteFinanzasFiltros = {
  fechaDesde?: string; // YYYY-MM-DD (inclusive)
  fechaHasta?: string; // YYYY-MM-DD (inclusive)
  campoFecha?: string; // factura | contable | orden
  identificadorProveedor?: string;
  estadoOrden?: number;
  tipoOrden?: number;
  tipoDocumento?: number;
  limit?: number;
  agrupacion?: string;
  tolerancia?: number;
};

// Builds the query string skipping empty values so the backend DTO
// validation only receives the filters that are actually set
const buildReporteQuery = (filtros: object = {}) => {
  const params = new URLSearchParams();
  Object.entries(filtros).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, String(value));
    }
  });
  const query = params.toString();
  return query ? `?${query}` : "";
};

const getReporteFinanzas = async (
  reporte: string,
  filtros?: ReporteFinanzasFiltros,
) => {
  const path = [
    `${PATH_GET_REPORTES_FINANZAS}/${reporte}${buildReporteQuery(filtros)}`,
  ];
  return await callApi(path, { method: "GET" });
};

export const GET_REPORTES_FINANZAS = {
  async getResumen(filtros?: ReporteFinanzasFiltros) {
    return await getReporteFinanzas("resumen", filtros);
  },
  async getProveedores(filtros?: ReporteFinanzasFiltros) {
    return await getReporteFinanzas("proveedores", filtros);
  },
  async getPeriodos(filtros?: ReporteFinanzasFiltros) {
    return await getReporteFinanzas("periodos", filtros);
  },
  async getEstadosCuadratura(filtros?: ReporteFinanzasFiltros) {
    return await getReporteFinanzas("estados-cuadratura", filtros);
  },
  async getTiposDocumento(filtros?: ReporteFinanzasFiltros) {
    return await getReporteFinanzas("tipos-documento", filtros);
  },
  async getEstadosOrden(filtros?: ReporteFinanzasFiltros) {
    return await getReporteFinanzas("estados-orden", filtros);
  },
  async getOrdenesSinFactura(filtros?: ReporteFinanzasFiltros) {
    return await getReporteFinanzas("ordenes-sin-factura", filtros);
  },
  async getDiferencias(filtros?: ReporteFinanzasFiltros) {
    return await getReporteFinanzas("diferencias", filtros);
  },
  async getAntiguedad(filtros?: ReporteFinanzasFiltros) {
    return await getReporteFinanzas("antiguedad", filtros);
  },
};

// Filters of the /reports/* endpoints. Each endpoint's DTO only accepts its
// own subset, so callers pass just the params that endpoint documents.
export type ReportesFiltros = {
  fechaDesde?: string; // YYYY-MM-DD (inclusive)
  fechaHasta?: string; // YYYY-MM-DD (inclusive)
  centrosCosto?: string; // "1,2,3" (cost centers picked by the user)
  // Scope of a user without cost center 29: their cost centers, plus (only
  // on solicitud data) the solicitudes they created as id_usuario_solicitante
  alcanceCentros?: string; // "9,45"
  alcanceSolicitante?: number;
  idArea?: number;
  idUsuario?: number;
  idProveedor?: number;
  idTipoDocumento?: number;
  idUser?: number; // subrogantes/resumen: logged-in user
  anio?: number; // resumen / presupuesto
  version?: number; // presupuesto: 0 base | 1 reformulado
  campoFecha?: string; // factura | contable | orden (facturas / pagos)
  agrupacion?: string; // dia | semana | mes | trimestre | anio
  limit?: number;
  ordenarPor?: string; // cantidad | monto
  page?: number; // trazabilidad
  idSolicitud?: number; // trazabilidad
  nroOrdenCompra?: number; // trazabilidad
};

const getReporte = async (reporte: string, filtros?: ReportesFiltros) => {
  const path = [
    `${PATH_GET_REPORTES}/${reporte}${buildReporteQuery(filtros)}`,
  ];
  return await callApi(path, { method: "GET" });
};

// Inicio: what is pending for the user, their recent documents and how many
// of their documents are at each step of the purchase process
export interface InicioResumenParams {
  idUser: number;
  idCentroCosto: number;
  centrosCostoVista: string;
  rolesSoc: boolean; // APRSOC / CONFSOC
  rolesOc: boolean; // APROC / CONFOC
  subroganteSoc: boolean; // mi_subrogancia_soc
  subroganteOc: boolean; // mi_subrogancia
}

export const GET_INICIO = {
  async getResumen(params: InicioResumenParams) {
    const path = [
      `${PATH_GET_REPORTES}/inicio/resumen${buildReporteQuery(params)}`,
    ];
    return await callApi(path, { method: "GET" });
  },
};

export const GET_REPORTES = {
  async getCatalogos() {
    return await getReporte("catalogos");
  },
  async getResumen(filtros?: ReportesFiltros) {
    return await getReporte("resumen", filtros);
  },
  // Ciclo completo
  async getCicloTiempos(filtros?: ReportesFiltros) {
    return await getReporte("ciclo/tiempos", filtros);
  },
  async getTrazabilidad(filtros?: ReportesFiltros) {
    return await getReporte("ciclo/trazabilidad", filtros);
  },
  // Solicitudes
  async getSolicitudesEstados(filtros?: ReportesFiltros) {
    return await getReporte("solicitudes/estados", filtros);
  },
  async getSolicitudesPeriodos(filtros?: ReportesFiltros) {
    return await getReporte("solicitudes/periodos", filtros);
  },
  async getSolicitudesUsuarios(filtros?: ReportesFiltros) {
    return await getReporte("solicitudes/usuarios", filtros);
  },
  async getSolicitudesCentrosCosto(filtros?: ReportesFiltros) {
    return await getReporte("solicitudes/centros-costo", filtros);
  },
  async getSolicitudesTipos(filtros?: ReportesFiltros) {
    return await getReporte("solicitudes/tipos", filtros);
  },
  async getSolicitudesAprobadores(filtros?: ReportesFiltros) {
    return await getReporte("solicitudes/aprobadores", filtros);
  },
  // Logged-in user's subrogancia: misSubrogantes + miActividadComoSubrogante
  async getSubrogantesResumen(filtros?: ReportesFiltros) {
    return await getReporte("subrogantes/resumen", filtros);
  },
  // Titular -> subrogante pairs and their approvals (solicitud_oc_aprobacion_historia)
  async getSolicitudesSubrogantes(filtros?: ReportesFiltros) {
    return await getReporte("solicitudes/subrogantes", filtros);
  },
  // Órdenes de compra
  async getOrdenesEstados(filtros?: ReportesFiltros) {
    return await getReporte("ordenes/estados", filtros);
  },
  async getOrdenesPeriodos(filtros?: ReportesFiltros) {
    return await getReporte("ordenes/periodos", filtros);
  },
  async getOrdenesCentrosCosto(filtros?: ReportesFiltros) {
    return await getReporte("ordenes/centros-costo", filtros);
  },
  async getOrdenesProveedores(filtros?: ReportesFiltros) {
    return await getReporte("ordenes/proveedores", filtros);
  },
  async getOrdenesItems(filtros?: ReportesFiltros) {
    return await getReporte("ordenes/items", filtros);
  },
  async getOrdenesMonedas(filtros?: ReportesFiltros) {
    return await getReporte("ordenes/monedas", filtros);
  },
  async getOrdenesCondicionesPago(filtros?: ReportesFiltros) {
    return await getReporte("ordenes/condiciones-pago", filtros);
  },
  async getOrdenesAprobadores(filtros?: ReportesFiltros) {
    return await getReporte("ordenes/aprobadores", filtros);
  },
  // Titular -> subrogante pairs and their approvals (orden_compra_aprobacion_historia)
  async getOrdenesSubrogantes(filtros?: ReportesFiltros) {
    return await getReporte("ordenes/subrogantes", filtros);
  },
  // Presupuesto (calendar year: anio + version)
  async getPresupuestoMensual(filtros?: ReportesFiltros) {
    return await getReporte("presupuesto/mensual", filtros);
  },
  async getPresupuestoCentrosCosto(filtros?: ReportesFiltros) {
    return await getReporte("presupuesto/centros-costo", filtros);
  },
  async getPresupuestoCuentas(filtros?: ReportesFiltros) {
    return await getReporte("presupuesto/cuentas", filtros);
  },
  // Heavy (lists every associated item): load on demand only
  async getPresupuestoNaturalezasItems(filtros?: ReportesFiltros) {
    return await getReporte("presupuesto/naturalezas-items", filtros);
  },
  // Pagos
  async getPagosResumen(filtros?: ReportesFiltros) {
    return await getReporte("pagos/resumen", filtros);
  },
  // Recepciones
  async getRecepcionesResumen(filtros?: ReportesFiltros) {
    return await getReporte("recepciones/resumen", filtros);
  },
  async getRecepcionesPendientes(filtros?: ReportesFiltros) {
    return await getReporte("recepciones/pendientes", filtros);
  },
};

// Filters of GET /notifications/email-log/ordenes-emitidas (dates apply to
// the first emission date of the OC)
export type EmailLogFiltros = {
  fechaDesde?: string; // YYYY-MM-DD (inclusive)
  fechaHasta?: string; // YYYY-MM-DD (inclusive)
  nroOrdenCompra?: number;
  idProveedor?: number;
  // enviado | rechazado | error | rebotado | abierto | confirmado | sin_envio
  estadoEmail?: string;
  page?: number;
  limit?: number; // max 200
};

export const GET_EMAIL_LOG = {
  async getOrdenesEmitidas(filtros?: EmailLogFiltros) {
    const path = [
      `${PATH_GET_EMAIL_LOG_ORDENES_EMITIDAS}${buildReporteQuery(filtros)}`,
    ];
    return await callApi(path, { method: "GET" });
  },
};

/* ########################################################################### */
/* ####################################### INET ############################## */
/* ########################################################################### */

export const SEND_ORDEN_COMPRA_INET = {
  async sendOrdenCompraInet(data: any, id: number) {
    var path = `${BASE_PATH_API_INET}${PATH_ADD_ORDEN_COMPRA_INET}?id=${id}`;
    const response = await fetch(path, {
      method: "POST",
      headers: {
        Authorization: STATIC_TOKEN_CONNECTION,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: data,
    });

    // 👇 ADD THIS TO CATCH THE VALIDATION ERROR 👇
    if (!response.ok) {
      const errorJson = await response.json().catch(() => ({}));
      console.error("❌ ERROR FROM INET HEADER API:", errorJson);
      return null;
    }

    return response;
  },
};

export const SEND_ORDEN_COMPRA_DETALLE_INET = {
  async sendOrdenCompraDetalleInet(data: any, id: number) {
    var path = `${BASE_PATH_API_INET}${PATH_ADD_ORDEN_COMPRA_DETALLE_INET}?id=${id}`;
    const response = await fetch(path, {
      method: "POST",
      headers: {
        Authorization: STATIC_TOKEN_CONNECTION,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: data,
    });

    // 👇 ADD THIS TO CATCH THE VALIDATION ERROR 👇
    if (!response.ok) {
      const errorJson = await response.json().catch(() => ({}));
      console.error("❌ ERROR FROM INET DETAIL API:", errorJson);
      return null;
    }

    return response;
  },
};

export const SEND_ORDEN_COMPRA_DETALLE_GLOSA_INET = {
  async sendOrdenCompraDetalleGlosaInet(data: any, id: number) {
    var path = `${BASE_PATH_API_INET}${PATH_ADD_ORDEN_COMPRA_DETALLE_GLOSA_INET}?id=${id}`;
    const response = await fetch(path, {
      method: "POST",
      headers: {
        Authorization: STATIC_TOKEN_CONNECTION,
        "Content-Type": "application/json",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "http://localhost:3000",
        "Access-Control-Allow-Methods":
          "GET, POST, PATCH, PUT, DELETE, OPTIONS",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
      },
      body: data,
    });
    return response;
  },
};

export const PUT_ORDEN_COMPRA_NULA_INET = {
  async putUpdateOrdenCompraNulaInet(id: number, data: any) {
    var path = `${BASE_PATH_API_INET}${PATH_PUT_ORDEN_COMPRA_NULA_INET}/${id}`;
    const response = await fetch(path, {
      method: "PUT",
      headers: {
        Authorization: STATIC_TOKEN_CONNECTION,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: data,
    });

    // 🔴 SI LA RESPUESTA NO ES EXITOSA (Status fuera del rango 200-299)
    if (!response.ok) {
      // Intentamos leer el JSON enviado por NestJS (BadRequestException)
      const errorJson = await response.json().catch(() => ({}));

      // Lanzamos un objeto de error que tu catch del componente pueda leer
      throw {
        status: response.status,
        message:
          errorJson.message || `Error ${response.status} al anular en Inet`,
        data: errorJson,
      };
    }

    // Si todo salió bien, podemos retornar los datos directamente o la respuesta limpia
    return await response.json().catch(() => response);
  },
};

/* ########################## FINANZAS - CONTABILIDAD INET ############################ */

export const SEND_RECEPCION_INET = {
  async sendRecepcionInet(data: any) {
    const path = `${BASE_PATH_API_INET}${PATH_ADD_RECEPCION_SERVICIOS_INET}`;

    try {
      const response = await fetch(path, {
        method: "POST",
        headers: {
          Authorization: STATIC_TOKEN_CONNECTION,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        // Ensure data is stringified regardless of whether an object or string was passed
        body: typeof data === "string" ? data : JSON.stringify(data),
      });

      if (!response.ok) {
        const errorBody = await response.text();
        console.error(`HTTP Error ${response.status}:`, errorBody);
        throw new Error(`HTTP Error ${response.status}: ${errorBody}`);
      }

      // Parse the actual JSON body sent by NestJS
      const parsedData = await response.json();
      return parsedData;
    } catch (error) {
      console.error("Error en sendRecepcionInet:", error);
      throw error;
    }
  },
};

export const POST_UPDATE_ORDEN_COMPRA_ESTADO_INET = {
  async postOrdenCompraEstadoInet(data: any) {
    //SEMI CUMPLIDA - ANULADA - CUMPLIDA
    var path = `${BASE_PATH_API_INET}${PATH_POST_ORDEN_COMPRA_ESTADO_INET}`;
    const response = await fetch(path, {
      method: "POST",
      headers: {
        Authorization: STATIC_TOKEN_CONNECTION,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: data,
    });

    // 🔴 SI LA RESPUESTA NO ES EXITOSA (Status fuera del rango 200-299)
    if (!response.ok) {
      // Intentamos leer el JSON enviado por NestJS (BadRequestException)
      const errorJson = await response.json().catch(() => ({}));

      // Lanzamos un objeto de error que tu catch del componente pueda leer
      throw {
        status: response.status,
        message:
          errorJson.message ||
          `Error ${response.status} al actualizar estado orden en Inet`,
        data: errorJson,
      };
    }

    // Si todo salió bien, podemos retornar los datos directamente o la respuesta limpia
    return await response.json().catch(() => response);
  },
};

/****** EJEMPLO PUT  *******/
/*export const PUT_USER_DATA_ONBOARD = {
    async putUserDataOnBoard(userId, data) {
      var path = `${PATH_PUT_USER_DATA_OB}${userId}`;
      const response = await callApi(path, {
        method: "PUT",
        body: data,
      });
      return response;
    },
  };
  // EJEMPLO POST
  export const POST_VOTE_DECISION_CONDO = {
    async postVoteDecisionCondo(condominio_id, idPropuesta, data) {
      var path = `${PATH_POST_VOTE_DECISION_CONDO}?idCondominio=${condominio_id}&idPropuesta=${idPropuesta}`;
      const response = await callApi(path, {
        method: "POST",
        body: data,
      });
      return response;
    },
  };
  // EJEMPLO DELETE
  export const CANCELA_RESERVA_CONDO = {
    //CANCELA UNA RESERVA DEL USUARIO PARA EL CONDOMINIO
    async cancelReservaCondo(idCondo, idReserva) {
      var path = `${PATH_CANCEL_RESERVACION_CONDO}?idCondo=${idCondo}&idReserva=${idReserva}`;
      const response = await callApi(path, {
        method: "DELETE",
      });
      console.log("CANCELA RESERVA RES: " + response);
      return response;
    },
  };*/
